import { Alert as NbAlert } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Alert = NbAlert;

export default addWithConfig(Alert);
